export default "__VITE_ASSET__CQ5o0Zsv__"